import { CircularProgress } from "@mui/material";
import { StreamProgressIndicator } from "@gui/widgets/StreamProgress/StreamProgressIndicator";
import type { PageAction } from "./PageLayout.types";

/** What a busy icon-only action draws in place of its icon: the determinate ring with the percentage
 *  when the action reports `busyProgress`, the plain spinner otherwise. */
export function BusyIcon(props: { action: Pick<PageAction, "busyProgress">; size: number }) {
	const progress = props.action.busyProgress;
	if (typeof progress === "number") {
		return <StreamProgressIndicator value={progress} size={props.size + 8} />;
	}
	return <CircularProgress size={props.size} color="inherit" />;
}
